import { Navigation } from '@/components/Navigation';
import { HomepageContent } from '@/components/homepage/HomepageContent';
import { Footer } from '@/components/Footer';
import { useEffect } from 'react';
import { trackPageView } from '@/utils/analytics';
import { CanonicalUrl } from '@/components/CanonicalUrl';
import { StructuredData } from '@/components/StructuredData';

// SEO Configuration
const SEO_CONFIG = {
  title: 'B2B Intent Data You Can Trust | Data Aviator',
  description: 'B2B intent data from ZoomInfo, Apollo, LinkedIn, Owler & 50+ verified sources. NCOA-verified every 30 days. Weekly refresh, consent-based buyer signals for demand gen teams.',
  keywords: 'B2B intent data, ZoomInfo data, Apollo data, LinkedIn data, Owler data, NCOA verified data, buyer intent signals, intent data platform, transparent data sourcing, compliant intent data, audience intelligence, demand generation data',
  ogTitle: 'Data Aviator - B2B Intent Data You Can Actually Trust',
  ogDescription: 'Aggregated from ZoomInfo, Apollo, LinkedIn, Owler & 50+ verified sources. NCOA-verified every 30 days. Consent-based buyer signals built for B2B teams.',
  twitterTitle: 'B2B Intent Data You Can Trust | Data Aviator',
  twitterDescription: 'ZoomInfo, Apollo, LinkedIn, Owler & 50+ sources. NCOA-verified every 30 days. Weekly refresh, consent-based intent signals.',
};

// FAQ items for homepage schema - optimized for AI quoting
const homepageFAQ = [
  {
    question: 'What is B2B intent data?',
    answer: 'B2B intent data is behavioral signals showing which companies are actively researching products or services like yours. It identifies in-market buyers based on their online research activity, content consumption, and purchase signals.',
  },
  {
    question: 'How often is Data Aviator intent data refreshed?',
    answer: 'Data Aviator refreshes intent data weekly every Monday. The platform processes 2 million opt-in records daily from 50+ verified sources.',
  },
  {
    question: 'Where does Data Aviator source its intent data?',
    answer: 'Data Aviator aggregates intent signals from 50+ verified sources including ZoomInfo, Apollo, LinkedIn, Owler, Dun & Bradstreet, Experian, Bombora, and more. All records are run through NCOA (National Change of Address) verification every 30 days to ensure accuracy. Sources are documented and auditable.',
  },
  {
    question: 'Is Data Aviator intent data privacy compliant?',
    answer: 'Yes. Data Aviator is GDPR, CCPA, and Texas TDPSA compliant. All data originates from sources where individuals have opted in or consented to data use. The platform maintains full data provenance documentation.',
  },
  {
    question: 'What is the match rate for Data Aviator data?',
    answer: 'Data Aviator delivers 95%+ match accuracy. The platform maintains 600M+ email records with B2B and B2C information, verified through skip-tracing and multi-source validation.',
  },
  {
    question: 'How does intent data improve ad performance?',
    answer: 'Ads served with intent signals have 30% higher consideration lift and 40% higher purchase intent lift compared to demographic targeting alone. Source: Google Brand Lift Targeting Analysis, 2018.',
  },
];

const Index = () => {
  useEffect(() => {
    trackPageView('/');
  }, []);

  return (
    <div className="min-h-screen bg-background">
<CanonicalUrl />
      
      {/* FAQ Schema for homepage */}
      <StructuredData
        type="FAQPage"
        questions={homepageFAQ}
      />
      
      <Navigation />
      
      <main>
        <HomepageContent />
      </main>
      
      <Footer />
    </div>
  );
};

export default Index;